import React, { useCallback } from 'react';
import { groupBy, sortBy } from 'lodash';
import { MenusDisplayResponse } from '../../services/displayFramework';
import { Menu } from 'antd';
import { Link } from 'react-router-dom';
import UtinaIcon from 'icons/UtinaIcon';
import getEnvValue from 'utils/getEnvValue';

const MainMenu = (menuFromContext: any) => {
  const menu = menuFromContext.menuFromContext;
  const menuItemsByParentId = groupBy(menu, 'itemidparent');
  const rootMenuItems = menuItemsByParentId['0'];

  let iconColor = 'white';

  try {
    let them = localStorage?.getItem('theme') ?? '{}';
    const newTheme = JSON?.parse(them);
    iconColor = newTheme?.textcolor;
  } catch (error) {}

  if (menu && !rootMenuItems) {
    console.warn('MainMenu - there is no root item in the menu');
  }
  const renderMenuItem = useCallback(
    ({
      itemid,
      itemlabel,
      pagurl,
      paglabel,
      pagicon,
      itemidparent,
      pagparams,
    }: MenusDisplayResponse) => {
      if (itemid === itemidparent) {
        console.warn(`MainMenu - itemid ${itemid} has parent ${itemidparent}`);
        return;
      }
      const nestedMenuItems = menuItemsByParentId[itemid];

      const icon = itemid ? (
        <UtinaIcon pagicon={pagicon} color={iconColor ?? 'white'} />
      ) : undefined;
      const label = itemlabel ?? paglabel;

      if (nestedMenuItems !== undefined) {
        return (
          <Menu.SubMenu key={itemlabel + itemid} title={label} icon={icon}>
            {sortBy(nestedMenuItems, 'itemorder').map(renderMenuItem)}
          </Menu.SubMenu>
        );
      }
      return (
        <Menu.Item key={itemlabel + itemid} icon={icon}>
          <Link to={pagurl + (pagparams === null ? '' : pagparams)}>
            {label}
          </Link>
        </Menu.Item>
      );
    },
    [menuItemsByParentId]
  );

  return (
    <Menu
    
      mode="horizontal"
      className="Menu"
      
    >
      {sortBy(rootMenuItems, 'itemorder').map(renderMenuItem)}
    </Menu>
  );
};

export default MainMenu;
